import { createAsyncThunk, createAction } from '@reduxjs/toolkit'
import api from '@services/api'
import { AxiosError } from 'axios'

export const setPack = createAction<{ storeId: string; packData: any[] }>('packs/setPack')

export const getPack = createAsyncThunk<void, string, { rejectValue: Record<string, string[]> }>(
  'packs/getPacks',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const pack: any = await api.getPack(id)
      // pack.map(bg => {
      //   const guid = nanoid()
      //   bg.bazaartId = guid
      //   let assetStateId = nanoid()
      //   bg.layerAssetStateId = assetStateId;

      //   let resizeThumbnailURL = getResizeUrl({ size: '0x32', url: bg.thumbnail.slice(8) })
      //   MediaImageRepositoryProvider.getEditingProjectInstance().storeImageUrl(guid, assetStateId, MediaImageType.thumbnail, resizeThumbnailURL)

      //   return bg
      // })
      dispatch(setPack({ storeId: id, packData: pack }))
    } catch (err) {
      return rejectWithValue(((err as AxiosError).response?.data as any)?.error.data || null)
    }
  }
)
